
// We decided to reuse this class format to make it easier to mantain and
// fix bugs consistently with /react-sf-poc-store-announcement-format/src/utilities/event-tracker/gclid

/* eslint-disable no-underscore-dangle */
/* eslint-disable-next-line max-classes-per-file */
export class GclidEUModel {
  * handleInit(isCookieAccepted) {
    if (isCookieAccepted) yield this.send(isCookieAccepted)
  }

  * handleConsentChanged(isCookieAccepted) {
    if (isCookieAccepted) yield this.send(isCookieAccepted)
  }
}

export class GclidNonEUModel {
  _lastValue = undefined;

  * handleInit(isCookieAccepted) {
    this._lastValue = isCookieAccepted
    yield this.send(isCookieAccepted)
  }

  * handleConsentChanged(isCookieAccepted) {
    if (this._lastValue === isCookieAccepted) return

    this._lastValue = isCookieAccepted
    yield this.send(isCookieAccepted)
  }
}
